import styled from 'styled-components';
import Tooltip from '../../../../../components/Tooltip';
import React, { useCallback, useContext } from 'react';
import Icon from '../../../../../kingpin/atoms/Icon';
import { SideBarStateContext } from './SideBarStateProvider';

const FloatingToggleWrapper = styled.div`
  position: absolute;
  top: 16px;
  left: 247px;
  height: 24px;
  width: 24px;
  border-radius: 12px;
  z-index: 100;
`;
const FloatingToggle = styled.div`
  height: 100%;
  width: 100%;
  border-radius: 12px;
  border: 1px solid var(--color-bg-sunken);
  background-color: var(--color-bg-primary);
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: var(--shadow-floating-button);

  &:hover {
    background-color: var(--color-bg-tertiary);
  }
`;

const FloatingToggleButton = styled.button`
  border: none;
  cursor: pointer;
  background-color: inherit;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  border-radius: 12px;
`;

const SideBarStateButton = () => {
  const { aniState, setAniState, appOrWorkspaceId } =
    useContext(SideBarStateContext);
  const onToggle = useCallback(() => {
    setAniState((current) => {
      if (current.isOpen) {
        localStorage.setItem(`v3Sidebar:${appOrWorkspaceId}`, 'closed');
        return {
          isOpen: false,
          isPinning: false,
          isHovered: false,
        };
      }

      localStorage.setItem(`v3Sidebar:${appOrWorkspaceId}`, 'open');
      return {
        isOpen: true,
        isPinning: true,
        isHovered: true,
      };
    });
  }, [appOrWorkspaceId, setAniState]);

  return (
    <FloatingToggleWrapper
      className={aniState.isOpen ? 'showPinOnMouseOver' : undefined}
    >
      <FloatingToggle>
        <Tooltip content={aniState.isOpen ? 'Hide menu' : 'Keep menu open'}>
          <FloatingToggleButton
            onClick={onToggle}
            aria-label={aniState.isOpen ? 'Hide menu' : 'Keep menu open'}
          >
            <Icon
              width={aniState.isOpen ? 20 : 16}
              height={aniState.isOpen ? 20 : 16}
              icon={aniState.isOpen ? 'chevron-left' : 'pushPin'}
            />
          </FloatingToggleButton>
        </Tooltip>
      </FloatingToggle>
    </FloatingToggleWrapper>
  );
};

export default SideBarStateButton;
